<template>
  <div>
    <b-form class="form">
      <b-form-group
      id="forgotten-old-pw"
      label-cols-sm="5"
      label-cols-lg="4"
      label="Régi jelszó:"
      label-for="forgotten-old-pw-input"
      label-align="left"
      >
        <b-form-input
          id="forgotten-old-password"
          v-model="oldPassword"
          type="password"
          required
        ></b-form-input>
      </b-form-group>
      <b-form-group
      id="forgotten-new-pw"
      label-cols-sm="5"
      label-cols-lg="4"
      label="Új jelszó:"
      label-for="forgotten-new-pw-input"
      label-align="left"
      >
        <b-form-input
          id="forgotten-new-pw-input"
          v-model="newPassword"
          type="password"
          required
          :state="this.newPassword !== null && newPassword.length >= 8 ? null : false"
        ></b-form-input>
      </b-form-group>
      <b-form-group
      id="forgotten-new-pw-again"
      label-cols-sm="5"
      label-cols-lg="4"
      label="Új jelszó újra:"
      label-for="forgotten-new-pw-again-input"
      label-align="left"
      >
        <b-form-input
          id="forgotten-new-pw-again-input"
          v-model="newPasswordAgain"
          type="password"
          required
          :state="newPassword === newPasswordAgain ? null : false"
        ></b-form-input>
      </b-form-group>
      <b-button id="login-button" @click="resolvePassword()" :disabled="!fieldsValid" type="button" variant="success">Módosítás</b-button>
    </b-form>
  </div>
</template>

<script>
import { changePassword } from '@/services/backendService'
import { mapActions } from 'vuex'

export default {
  name: "ForgottenPassword",
  props: {
    userName: {
      required: false,
      default: atob(localStorage.getItem('user')).split(':')[0]
    }
  },
  data() {
    return {
      oldPassword: null,
      newPassword: null,
      newPasswordAgain: null,
      formStates: {
        newValid: null,
        newValidAgain: null,
        buttonValid: false
      }
    }
  },
  computed: {
    fieldsValid() {
      return this.newPassword === this.newPasswordAgain && this.newPassword !== null && this.newPassword.length >= 8 && !!this.oldPassword
    },
  },
  methods: {
    ...mapActions(["signUserIn"]),
    async resolvePassword() {
      try {
        let response = await changePassword(this.userName, this.oldPassword, this.newPassword)
        this.signUserIn(btoa(this.userName + ":" + this.newPassword))
        this.$router.push("/")
        alert('Sikeres jelszó módosítás')
      } catch(err) {
        if(err.response.status > 200) {
          alert(err.response.data.status_uzenet)
        }
      }
    }
  },
  mounted() {
    if(this.userName === undefined) {
      this.$router.push("/belepes")
    }
  }
}
</script>

<style lang="scss" scoped>
.form {
  width: 400px
}
div {
  display: flex;
  align-items: center;
  justify-content: center;
}
.forgot-input {
  width: 400px;
}
</style>

